import { getConfig } from '../config';

const { adminUrl, atlassianAccountUrl, macUrl, supportUrl, wacUrl } = getConfig();

export const LINK_URLS = {
  ADMIN_ATLASSIAN: adminUrl,
  LICENSING: macUrl,
  MANAGE_PROFILE: `${atlassianAccountUrl}/manage-profile`,
  SUPPORT: supportUrl,
  WAC: wacUrl,
};
